import { useEffect, useState } from "react";
import axios from "axios";
import { FileSignature, Trophy } from "lucide-react";
import { TIM_COLOR } from "../../lib/dashConstants";
import { fmtN } from "../../lib/format";
import { API } from "../../lib/api";

/**
 * Sales Leaderboard — Top Performer.
 * Aturan ranking: EFT Closed terbanyak (utama), lalu Siswa TeachCast terbanyak.
 * BUKAN berdasarkan jumlah aktivitas.
 */
export default function Leaderboard({ data, onRowClick }) {
  const [eftMap, setEftMap] = useState({});

  useEffect(() => {
    axios.get(`${API}/eft/analytics`)
      .then((r) => {
        const m = {};
        (r.data?.top_performers || []).forEach((p) => {
          m[String(p.nama_sales).toLowerCase()] = {
            eft_closed: p.eft_closed || 0,
            teachcast_students: p.teachcast_students || 0,
          };
        });
        setEftMap(m);
      })
      .catch(() => setEftMap({}));
  }, []);

  if (!data || !data.length) return <div className="empty">Tidak ada data.</div>;

  // Gabungkan metrik EFT + TeachCast, lalu urutkan sesuai aturan Top Performer
  const rows = data.map((d) => {
    const e = eftMap[String(d.nama_sales).toLowerCase()] || {};
    return {
      ...d,
      eft_closed: e.eft_closed || 0,
      teachcast_students: e.teachcast_students || 0,
    };
  }).sort((a, b) =>
    (b.eft_closed - a.eft_closed) || (b.teachcast_students - a.teachcast_students)
  );

  const maxClosed = Math.max(...rows.map((d) => d.eft_closed), 1);

  return (
    <table className="tbl" data-testid="leaderboard-table">
      <thead>
        <tr>
          <th style={{ width: 36 }}>#</th>
          <th>Sales</th>
          <th>Tim</th>
          <th className="text-right">EFT Closed</th>
          <th className="text-right">Siswa TeachCast</th>
          <th className="text-right">Jumlah Sekolah</th>
          <th className="text-right">Agreement Sign</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.nama_sales} className={onRowClick ? "row-click" : ""} onClick={() => onRowClick && onRowClick(r)}>
            <td><span className="badge navy" style={{ minWidth: 18, textAlign: "center" }}>{i + 1}</span></td>
            <td style={{ fontWeight: 600, color: "var(--navy)" }}>
              {i === 0 && <Trophy size={12} color="#F39C12" style={{ marginRight: 4, verticalAlign: "-2px" }} />}
              {r.nama_sales}
            </td>
            <td>
              {r.tim_sales ? (
                <span className="badge" style={{ background: TIM_COLOR[r.tim_sales] + "22", color: TIM_COLOR[r.tim_sales], borderColor: TIM_COLOR[r.tim_sales] + "55" }}>
                  {r.tim_sales}
                </span>
              ) : "—"}
            </td>
            <td className="text-right" style={{ fontVariantNumeric: "tabular-nums", fontWeight: 700 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "flex-end" }}>
                <div style={{ height: 6, borderRadius: 3, background: "#E7F6EC", width: 60, position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", inset: 0, width: `${(r.eft_closed / maxClosed) * 100}%`,
                    background: "linear-gradient(90deg, #27AE60, #1E8449)", borderRadius: 3 }} />
                </div>
                <span style={{ minWidth: 32, color: "var(--good)" }}>{fmtN(r.eft_closed)}</span>
              </div>
            </td>
            <td className="text-right" style={{ fontVariantNumeric: "tabular-nums", fontWeight: 600, color: "var(--accent)" }}>
              {fmtN(r.teachcast_students)}
            </td>
            <td className="text-right" style={{ fontVariantNumeric: "tabular-nums" }}>{fmtN(r.sekolah_unik)}</td>
            <td className="text-right">
              <span className={`badge ${r.agreement_sign > 0 ? "green" : ""}`}>
                <FileSignature size={10} style={{ verticalAlign: "-1px", marginRight: 4 }} />
                {fmtN(r.agreement_sign)}
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
